import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { Heading } from '@domain-group/fe-co-allhomes-design-system';
import SingleCard from './single-card';
import Slider from './slider';
import EmptyState from './empty-state';
import * as styles from './property-history.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var PropertyHistory = props => ___EmotionJSX("div", {
  css: styles.propertyHistory
}, ___EmotionJSX(Heading, {
  title: "Property history"
}), isEmpty(props.cards) ? ___EmotionJSX(EmptyState, {
  suburbName: props.suburbInfo.name,
  suburbLink: props.suburbInfo.link
}) : ___EmotionJSX(Slider, {
  cards: props.cards,
  isOnMarket: props.isOnMarket,
  showOnboarding: props.showOnboarding,
  onSwipeLeft: props.onSwipeLeft,
  onSwipeRight: props.onSwipeRight,
  onTapRightChevron: props.onTapRightChevron,
  onTapLeftChevron: props.onTapLeftChevron,
  onExpand: props.onExpand,
  onCollapse: props.onCollapse,
  onPhotoClick: props.onPhotoClick,
  expandedIndices: props.expandedIndices
}));
PropertyHistory.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.shape(SingleCard.propTypes)),
  suburbInfo: PropTypes.shape({
    name: PropTypes.string,
    link: PropTypes.string
  }),
  isOnMarket: PropTypes.bool,
  onSwipeLeft: PropTypes.func,
  onSwipeRight: PropTypes.func,
  onTapRightChevron: PropTypes.func,
  onTapLeftChevron: PropTypes.func,
  onExpand: PropTypes.func,
  onCollapse: PropTypes.func,
  onPhotoClick: PropTypes.func,
  showOnboarding: PropTypes.bool,
  expandedIndices: PropTypes.arrayOf(PropTypes.number)
};
PropertyHistory.defaultProps = {
  isOnMarket: false,
  cards: [],
  suburbInfo: {},
  onSwipeLeft: () => {},
  onSwipeRight: () => {},
  onTapRightChevron: () => {},
  onTapLeftChevron: () => {},
  onExpand: () => {},
  onCollapse: () => {},
  onPhotoClick: () => {},
  showOnboarding: true,
  expandedIndices: []
};
export default PropertyHistory;